import Navbar from "../../components/navigations/navbar"
import Section1 from "./sections/section_1"
import Section10 from "./sections/section_10"
import Section2 from "./sections/section_2"
import Section3 from "./sections/section_3"
import Section4 from "./sections/section_4"
import Section5 from "./sections/section_5"
import Section6 from "./sections/section_6"
import Section7 from "./sections/section_7"
import Section8 from "./sections/section_8"
import Section9 from "./sections/section_9"

const LandingPage = () => {
    return (
        <>
            <div className="w-full h-screen bg-white text-black ">
                <Navbar />
                <Section1 />
                <Section2 />
                <Section3 />
                <Section4 />
                <Section5 />
                <Section6 />
                <Section7 />
                <Section8 />
                <Section9 />
                <Section10 />
            </div>
        </>
    )
}

export default LandingPage